import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegacyShellComponent } from './layout/legacy/legacy-shell.component';
import { ModernShellComponent } from './layout/modern/modern-shell.component';
import { LayoutService } from './core/services/layout.service';
import { AppShellService } from './core/services/app-shell.service';
import { FeatureFlagsService } from './core/services/feature-flags.service';
import { ThemeService } from './core/services/theme.service';
import { UiToastHostComponent } from './ui/toast/ui-toast-host.component';
import { UiModalHostComponent } from './ui/modal/ui-modal-host.component';
import { UiLightboxHostComponent } from './ui/lightbox/ui-lightbox-host.component';

@Component({
  selector: 'veitros-root',
  imports: [
    CommonModule,
    LegacyShellComponent,
    ModernShellComponent,
    UiToastHostComponent,
    UiModalHostComponent,
    UiLightboxHostComponent,
  ],
  template: `
    @if (layoutService.useModernLayout()) {
      <veitros-modern-shell />
    } @else {
      <veitros-legacy-shell />
    }
    <ui-toast-host />
    <ui-modal-host />
    <ui-lightbox-host />
  `,
  standalone: true,
})
export class App implements OnInit {
  layoutService = inject(LayoutService);
  shell = inject(AppShellService);
  private featureFlags = inject(FeatureFlagsService);
  private themeService = inject(ThemeService);

  /** @deprecated Use AppShellService. */
  associacaoLogoSig = this.shell.associacaoLogoSig;
  associacaoNameSig = this.shell.associacaoNameSig;
  associacaoColorPrimarySig = this.shell.associacaoColorPrimarySig;
  associacaoColorSecondarySig = this.shell.associacaoColorSecondarySig;

  getAppVersion(): string {
    return this.shell.getAppVersion();
  }

  ngOnInit(): void {
    if (this.layoutService.useModernLayout()) {
      this.themeService.activate();
    } else {
      this.themeService.deactivate();
    }

    void this.featureFlags.load();
    this.shell.init();
  }
}
